export default function SearchBar({ search, setSearch }) {
  return (
    <input
      type="text"
      placeholder="Search jewellery..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="w-full md:w-72 px-4 py-2 border rounded-lg shadow-sm
                 focus:outline-none focus:ring-2 focus:ring-indigo-300"
    />
  );
}
